import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ExpenseService {

	private URL = environment.api + "api/erp/expense";

	constructor(private http: HttpClient) { }

	getDocuments(startDate: any, endDate: any) {
		return this.http.get(this.URL + "/documents/" + startDate + "/" + endDate);
	}

	getDetailDocument(idDocument) {
		return this.http.get(this.URL + "/expense-doc-detail/" + idDocument);
	}

	getDetailsDocumentTemp(idDocument) {
		return this.http.get(this.URL + "/expense-doc-temp/" + idDocument);
	}

	getExpensesGeneralEstablishment(startDate: number, endDate: number) {
		return this.http.get(this.URL + `/generalestablishment/${startDate}/${endDate}`);
	}

	getExpensesTypeEstablishment(startDate: number, endDate: number) {
		return this.http.get(this.URL + `/typeestablishment/${startDate}/${endDate}`);
	}

	getLotsExpense() {
		return this.http.get(this.URL + `/lots`);
	}

	getLotExpenseById(idLot) {
		return this.http.get(this.URL + `/lot/${idLot}`);
	}

	getDocumentTypes() {
		return this.http.get(this.URL + `/docTypes`);
	}

	setTempExpense(idLocation, request) {
		return this.http.post(this.URL + `/temp?location=${idLocation}`,request);
	}

	getTempExpenses(idLocation) {
		return this.http.get(this.URL + `/temp/type/1/0?location=${idLocation}`);
	}

	deleteTempExpense(idTempExpense) {
		return this.http.delete(this.URL + `/temp/${idTempExpense}`);
	}

	updateTempExpense(idTempExpense, request) {
		return this.http.put(this.URL + `/temp/${idTempExpense}`,request);
	}

	makeTempExpenses(idLocation, request) {
		return this.http.post(this.URL + `/makeTemporals/1?location=${idLocation}`,request);
	}

	makeTempExpensesAdministrative(idLocation, request) {
		return this.http.post(this.URL + `/makeTemporals-administrative/1?location=${idLocation}`,request);
	}

	makeLotTempExpenses(currency, request) {
		return this.http.post(this.URL + `/lot?currency=${currency}`,request);
	}

	setTempPPE(request) {
		return this.http.post(this.URL + `/temp`,request);
	}

	setTranslateTempPPE(documentId) {
		return this.http.post(this.URL + `/translate-expense/${documentId}`,{});
	}

	getTempPPE() {
		return this.http.get(this.URL + `/temp/type/4/0`);
	}

	deleteTempPPE() {
		return this.http.delete(this.URL + `/temp/type/4`);
	}

	saveApplyPP(data: any, documentId: any) {
		return this.http.post(this.URL + `/applies-pp/${documentId}`, data);
	}

	getExpenseDoc(expenseDocId) {
		return this.http.get(this.URL + `/singleDocument?id=${expenseDocId}`);
	}
}
